import React from 'react';
import {
  Typography,
  Form,
  Input,
  Upload,
  Button,
  Col,
  Row,
  Radio,
  message
} from 'antd';
import {
  // PhoneOutlined,
  MessageOutlined,
  MailOutlined,
  UploadOutlined
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.less';
import { submitHelpRequest } from '../redux/slice';

const { Title, Text } = Typography;
export const FEEDBACK_TYPES = [
  { label: 'Appreciation', value: 'appreciation' },
  { label: 'Inquiry', value: 'inquiry' },
  { label: 'Suggestion', value: 'suggestion' },
  { label: 'Complaint', value: 'complaint' }
];

export const RATING_OPTIONS = [
  { label: 'Account Issues', value: 'Account Issues' },
  { label: 'Profile Assistance', value: 'Profile Assistance' },
  { label: 'Subscription & Payment', value: 'Subscription & Payment' },
  { label: 'Matchmaking Issues', value: 'Matchmaking Issues' },
  { label: 'Other', value: 'Other' }
];

export const CONTACT_METHODS = [
  { label: 'Call', value: 'call' },
  { label: 'Message', value: 'message' },
  { label: 'Both', value: 'both' }
];

const HelpCenter = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { helpcenterloading } = useSelector((state) => state.helpcenter);
  console.log('helpcenterloading', helpcenterloading);

  const onSubmit = async () => {
    try {
      const values = await form.validateFields();

      // Extract form values
      const userName = values.user_name || '';
      const profileId = values.profile_id || '';
      const email = values.user_email || '';
      const phoneNumber = values.phoneNumber || '';
      const issueCategory = values.issue_category || '';
      const otherIssue = values.other_issue || '';
      const contactMethod = values.contact_method || '';
      const files = values.attachments?.fileList || [];

      // Prepare FormData
      const formData = new FormData();
      formData.append('name', userName);
      formData.append('profile_unique_id', profileId);
      formData.append('phone_number', phoneNumber);
      formData.append('email', email);
      formData.append('category', issueCategory);
      formData.append('custom_category', otherIssue);
      formData.append('contact_method', contactMethod);

      // Append all uploaded files
      files.forEach((file) => {
        formData.append('user_request_images', file.originFileObj);
      });

      console.log('Submitting FormData:', formData);

      // Dispatch API call
      const response = await dispatch(submitHelpRequest(formData));
      if (response?.payload?.success) {
        message.success(
          response?.payload?.message || 'Feedback submitted successfully!'
        );
        navigate(`/dashboard`);
        form.resetFields();
        // window.location.href = '/dashboard';
        // setTimeout(() => {
        //   navigate('/dashboard'); // Use navigate instead of window.location.href
        // }, 2000); // Delay for user to see success message
      } else {
        console.error('API call failed:', response?.payload?.message);
        message.error(
          response?.payload?.message || 'Failed to submit feedback.'
        );
      }
    } catch (error) {
      console.error('Error submitting feedback:', error);
      message.error(error?.message || 'Error submitting feedback.');
    }
  };

  const navigateToDashboard = () => {
    window.location.href = '/dashboard';
  };

  const matUserData = localStorage.getItem('MAT-User');
  const matUserObject = JSON.parse(matUserData);
  const email = matUserObject.user_details.email;
  const fname = matUserObject.user_details.first_name;
  const lname = matUserObject.user_details.last_name;
  const profile_id = matUserObject.user_details.profile_unique_id;
  const phone_num = matUserObject.user_details.phone_number;

  form.setFieldsValue({ user_email: email });
  form.setFieldsValue({ user_name: `${fname} ${lname}` });
  form.setFieldsValue({ profile_id: profile_id });
  form.setFieldsValue({ phoneNumber: phone_num });

  return (
    <div className={styles.maincontainer}>
      <div>
        <Row className={styles.container} gutter={24}>
          <Col xl={24} lg={24} md={24} sm={24} xs={24}>
            <div>
              <button className={styles.back} onClick={navigateToDashboard}>
                Back
              </button>
            </div>
          </Col>
          <Col xl={8} lg={24} md={24} sm={24} xs={24}>
            <div className={styles.help_section}>
              <Title level={2} className={styles.title}>
                Need Help?
              </Title>
              <Text className={styles.subtitle}>
                We`re here to connect you with your match.
              </Text>

              <div className={styles.contact_container}>
                {/* <div className={styles.contact_item}>
                  <div className={styles.icon_text}>
                    <PhoneOutlined
                      className={styles.icon}
                      style={{ color: 'red', transform: 'scaleX(-1)' }}
                    />
                    <Text
                      className={styles.contact_title}
                      style={{ color: 'red', fontFamily: 'teachers' }}
                    >
                      Call us Now !
                    </Text>
                  </div>
                  <div className={styles.divider}></div>
                  <div className={styles.contact_info}>
                    <Text className={styles.textColor}>Monday – Friday</Text>
                    <br></br>
                    <Text className={styles.textColor}>9.30 – 17.30 IST</Text>
                  </div>
                </div> */}
                <div className={styles.contact_item}>
                  <div className={styles.icon_text}>
                    <MessageOutlined className={styles.icon} />
                    <Text className={styles.contact_title}>Let`s Chat</Text>
                  </div>
                  <div className={styles.divider}></div>
                  <div className={styles.contact_info}>
                    <Text className={styles.textColor}>Monday – Friday</Text>
                    <br></br>
                    <Text className={styles.textColor}>9.00 – 18.00 IST</Text>
                  </div>
                </div>
              </div>

              <div className={styles.contact_container}>
                <div className={styles.contact_item}>
                  <div className={styles.icon_text}>
                    <MailOutlined
                      className={styles.icon}
                      style={{ color: 'red', transform: 'scaleX(-1)' }}
                    />
                    <Text
                      className={styles.contact_title}
                      style={{ color: 'red', fontFamily: 'teachers' }}
                    >
                      Write to us
                    </Text>
                  </div>
                  <div className={styles.divider}></div>
                  <div className={styles.contact_info}>
                    {/* <Text className={styles.textColor}>Monday – Friday</Text>
                    <br></br>
                    <Text className={styles.textColor}>9.30 – 17.30 IST</Text> */}
                    <Text>
                      <a
                        href="mailto:info@samskrutimatrimony.com"
                        // style={{ fontSize: '18px' }}
                        className={styles.textMailColor}
                      >
                        info@samskrutimatrimony.com
                      </a>
                    </Text>
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col xl={16} lg={24} md={24} sm={24} xs={24}>
            <div className={styles.feedForm}>
              <div className={styles.feedback_container}>
                <Form
                  form={form}
                  layout="vertical"
                  className={styles.feedback_form}
                >
                  <div className={styles.feedback_section2}>
                    <h2 className={styles.per}> Personal Information</h2>
                    <div className={styles.inner}>
                      <div className={styles.inner1}>
                        <Form.Item label="Name" name="user_name">
                          <Input placeholder="Enter your Name" disabled />
                        </Form.Item>
                      </div>
                      <div className={styles.inner1}>
                        <Form.Item label="Profile ID" name="profile_id">
                          <Input placeholder="Enter your Profile ID" disabled />
                        </Form.Item>
                      </div>
                    </div>
                    <div className={styles.inner}>
                      <div className={styles.inner1}>
                        <Form.Item label="Email" name="user_email">
                          <Input placeholder="Enter your Email" />
                        </Form.Item>
                      </div>
                      <div className={styles.inner1}>
                        <Form.Item
                          label="Phone Number"
                          name="phoneNumber"
                          rules={[
                            {
                              required: false,
                              message: 'Please enter a valid phone number'
                            },
                            {
                              pattern: /^[0-9]{10}$/,
                              message: 'Phone number must be up to 10 digits'
                            }
                          ]}
                        >
                          <Input
                            placeholder="Enter your Phone Numberss"
                            maxLength={10}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>

                  <div className={styles.feedback_section2}>
                    <h2 className={styles.per}>Issue Details </h2>
                    <Form.Item
                      label="Choose your Issue Category ?"
                      name="issue_category"
                    >
                      <Radio.Group
                        options={RATING_OPTIONS}
                        className={styles.custom_checkbox_group2}
                      />
                    </Form.Item>

                    <Form.Item
                      label="If you Choose Other Mention your Issue"
                      name="other_issue"
                    >
                      <Input.TextArea
                        placeholder="Specify your concern or issue here..."
                        autoSize
                        className={styles.custom_textarea}
                      />
                    </Form.Item>

                    <Form.Item
                      label="Attach images (optional)"
                      name="attachments"
                    >
                      <Upload beforeUpload={() => false} multiple>
                        <Button
                          icon={<UploadOutlined />}
                          className={styles.upload_btn}
                        >
                          Click to Upload
                        </Button>
                      </Upload>
                    </Form.Item>

                    <Form.Item
                      label="Choose your Contact Method"
                      name="contact_method"
                    >
                      <Radio.Group
                        options={CONTACT_METHODS}
                        className={styles.custom_checkbox_group2}
                      />
                    </Form.Item>

                    <div className={styles.buttonSet}>
                      <Button
                        className="back"
                        onClick={onSubmit}
                        loading={helpcenterloading}
                        disabled={helpcenterloading}
                      >
                        Submit
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default HelpCenter;
